import { render, staticRenderFns } from "./DockMenuCard.vue?vue&type=template&id=25de50af&scoped=true&"
import script from "./DockMenuCard.vue?vue&type=script&lang=js&"
export * from "./DockMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./DockMenuCard.vue?vue&type=style&index=0&id=25de50af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de50af",
  null
  
)

export default component.exports